"use client";

import { PageAdBlocksTypes } from "@/types/page";
import { getImageUrl } from "@/utils/getImageUrl";
import { unescapeHTML } from "@/utils/unescapeHtml";
import { useEffect } from "react";

type AdBannerProps = {
  advertisementData?: PageAdBlocksTypes;
  dataAdSlot?: string;
};

const AdBanner = (props: AdBannerProps) => {
  const scriptContent =
    props?.advertisementData?.adCode && props?.advertisementData?.adCode?.length > 0
      ? unescapeHTML(props?.advertisementData?.adCode)
      : null;

  useEffect(() => {
    const scriptElement = document.querySelector(
      `script[src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${process.env.NEXT_PUBLIC_GOOGLE_AD_CLIENT_ID}"]`,
    );

    const handleScriptLoad = () => {
      try {
        if (window.adsbygoogle) {
          console.log("adsense script is loaded, pushing ads");
          ((window as any).adsbygoogle = (window as any).adsbygoogle || []).push({});
        } else {
          scriptElement!.addEventListener("load", handleScriptLoad);
          console.log("waiting until adsense script is loaded");
        }
      } catch (err) {
        console.log(err);
      }
    };

    handleScriptLoad();

    return () => {
      if (scriptElement) {
        scriptElement.removeEventListener("load", handleScriptLoad);
      }
    };
  }, []);

  if (process.env.NEXT_PUBLIC_ENABLE_ADS !== "true") return null;

  return (
    <>
      {scriptContent ? (
        <div
          style={{ width: "100%", overflow: "auto" }}
          dangerouslySetInnerHTML={{ __html: scriptContent }}
        />
      ) : props.advertisementData?.adImage ? (
        props?.advertisementData?.link ? (
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={props?.advertisementData?.link}
            style={{ width: "100%" }}
          >
            <img
              src={getImageUrl(props?.advertisementData?.adImage?.sizes?.md?.filename || "")}
              alt="ad"
              className={`object-contain w-full ${
                props?.advertisementData?.adShape === "vertical" ? "" : "h-full"
              }`}
            />
          </a>
        ) : (
          <img
            src={getImageUrl(props?.advertisementData?.adImage?.sizes?.md?.filename || "")}
            alt="ad"
            className={`object-contain w-full ${
              props?.advertisementData?.adShape === "vertical" ? "" : "h-full"
            }`}
          />
        )
      ) : (
        <div style={{ width: "100%", overflow: "auto" }}>
          <ins
            className="adsbygoogle"
            style={{ display: "block" }}
            data-ad-client={process.env.NEXT_PUBLIC_GOOGLE_ADS_CLIENT_ID}
            data-ad-slot={props.dataAdSlot}
            data-ad-format="auto"
            data-full-width-responsive="true"
          />
        </div>
      )}
    </>
  );
};

export default AdBanner;
